
//Letters(a - z, A - Z)
//Numbers(0 - 9)
//Special characters: + - _ .
//Empty space

export const AllowedSpecialCharacters = (event) => {
    const regex = /^[a-zA-Z0-9+\-_. ]$/;
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Delete', 'Home', 'End'];

    if (!regex.test(event.key) && !allowedKeys.includes(event.key)) {
        event.preventDefault();
    }
}

export const AllowedSpecialCharactersPaste = (event) => {
    const regex = /^[a-zA-Z0-9+\-_. ]*$/;
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Delete', 'Home', 'End'];
    const pastedText = event.clipboardData.getData("text");

    if (!regex.test(pastedText) && !allowedKeys.includes(pastedText)) {
        event.preventDefault();
    }
}